
import lowScreenImg from '../assests/low-screen-img.jpg'
import BrandedLogo from './branded-logo'

const LowScreen = () => {
    return (
        <div className='w-[100%] h-[100%] bg-background z-[99999] fixed top-0 low-screen flex flex-col'>
            <div className='bg-surface border-b border-edge w-[100%] flex items-center justify-center py-6 shadow-card'>
                <BrandedLogo className="w-[250px] min-w-[250px] rounded-lg opacity-95" />
            </div>

            <div className='h-full w-[90%] flex items-center justify-center flex-col mx-auto'>
                <img src={lowScreenImg} className='w-[80%] md:w-[60%] rounded-2xl opacity-90' alt='No Screen' />
                <h2 className='text-text-primary text-center font-heading-font text-3xl my-4'>PremSure is best view on desktop</h2>
                <p className='text-light-gray text-center font-[400] text-md'>For a complete experience please login
                    on a desktop device.</p>
            </div>
        </div>
    )
}

export default LowScreen
